"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChargingTransactionSerialization = void 0;
class ChargingTransactionSerialization {
    static serialize(entity) {
        const copy = { ...entity };
        copy.plug_in_start_utc = entity.plug_in_start_utc
            ? entity.plug_in_start_utc.getTime() * 1000000
            : undefined;
        copy.plug_in_stop_utc = entity.plug_in_stop_utc
            ? entity.plug_in_stop_utc.getTime() * 1000000
            : undefined;
        copy.charging_transaction_start_utc = entity.charging_transaction_start_utc
            ? entity.charging_transaction_start_utc.getTime() * 1000000
            : undefined;
        copy.charging_transaction_end_utc = entity.charging_transaction_end_utc
            ? entity.charging_transaction_end_utc.getTime() * 1000000
            : undefined;
        copy.time_power_limited_ns = entity.time_power_limited_ns
            ? entity.time_power_limited_ns.getTime() * 1000000
            : undefined;
        copy.idle_time_start_utc = entity.idle_time_start_utc
            ? entity.idle_time_start_utc.getTime() * 1000000
            : undefined;
        copy.idle_time_end_utc = entity.idle_time_end_utc
            ? entity.idle_time_end_utc.getTime() * 1000000
            : undefined;
        return JSON.stringify(copy);
    }
    static deserialize(msg) {
        const entity = JSON.parse(msg);
        const copy = { ...entity };
        copy.plug_in_start_utc = entity.plug_in_start_utc
            ? new Date(entity.plug_in_start_utc / 1000000)
            : undefined;
        copy.plug_in_stop_utc = entity.plug_in_stop_utc
            ? new Date(entity.plug_in_stop_utc / 1000000)
            : undefined;
        copy.charging_transaction_start_utc = entity.charging_transaction_start_utc
            ? new Date(entity.charging_transaction_start_utc / 1000000)
            : undefined;
        copy.charging_transaction_end_utc = entity.charging_transaction_end_utc
            ? new Date(entity.charging_transaction_end_utc / 1000000)
            : undefined;
        copy.time_power_limited_ns = entity.time_power_limited_ns
            ? new Date(entity.time_power_limited_ns / 1000000)
            : undefined;
        copy.idle_time_start_utc = entity.idle_time_start_utc
            ? new Date(entity.idle_time_start_utc / 1000000)
            : undefined;
        copy.idle_time_end_utc = entity.idle_time_end_utc
            ? new Date(entity.idle_time_end_utc / 1000000)
            : undefined;
        return copy;
    }
}
exports.ChargingTransactionSerialization = ChargingTransactionSerialization;
